export interface IDayOfWeek {
    dayWeekId: string;
    dia: string;
    tenantId: number;
    language: string;
}